/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:40:05
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from 500 Shillings,you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "1-Month Warranty",
    name19: "Enjoy a 1‑month official warranty on your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a one-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name29: "5. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at:709 698 888.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Statements:",
    name32: "View Applicable Models & Price",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "View Applicable Models & Price",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
    name43: "Flat Price Battery Replacement",
    name44: "Starting from 500 Shillings",
  },
  order: {
    name1: "選擇裝置型號",
    name2: "故障說明：",
    name3: "點按即可選取服務商店",
    name4: "服務商店：",
    name5: "預約時間：",
    name6: "請詳細說明您的裝置問題！",
    name7: "點按即可選取到達時間",
    name8: "請輸入正確、詳細的聯絡資訊，以便讓我們與您聯繫",
    name9: "許可的預約時間如下",
    name10: "請輸入手機號碼",
    name11: "價格",
    name12: "個人資訊：",
    name13: "請輸入您的名稱",
    name14: "提交",
    name15: "取消",
    name16: "確定",
  },
  shops: {
    name1: "根據您選擇的品牌，以下商店可為您服務！",
    name2: "即將在更多零售商店中亮相！千萬別錯過！",
  },
  price: {
    name1: "品牌",
    name2: "型號",
    name3: "項",
    name4: "價格",
    name5: "溫馨提示：",
    name6: "這些價格僅供參考，實際價格是取決於您裝置的條件。",
    name7: "如果沒有特殊符號，價格是以當地貨幣為計價單位。",
    name8: "很抱歉！ 目前所在地區未提供價格資訊。",
    name11:"人工費用",
    name12:"總價",
    name13: "5. 如果人工成本為 \"/\"，則表示需要前往店面諮詢。",
    item_main_board: "Mainboard",
    item_screen_frame: "Screen(Frame)",
    item_screen_screen_frame: "Secondary Screen(Frame)",
    item_touch_screen: "Touch Screen",
    item_camera: "Camera",
    item_fixed_focus_camera: "Fixed Focus Camera",
    item_auto_focus_camera: "Auto Focus Camera",
    item_screen: "Screen",
    item_secondary_screen: "Secondary Screen",
    item_fingerprint_module: "Fingerprint Module",
    item_speaker: "Speaker",
    item_receiver: "Receiver",
    item_small_board: "Small Board",
    item_battery_cover: "Battery Cover",
    item_battery: "Battery",
    item_charger: "Charger",
    item_usb_cable: "USB Cable",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "無資料",
    name2: "服務供應商：",
    name3: "服務品牌：",
    name4: "電話：",
    name5: "訂單數量：",
    name6: "服務評價",
    name7: "服務環境：",
    name8: "服務態度：",
    name9: "服務效率：",
    name10: "服務品質：",
    name11: "客戶評估",
    name12:"至",
    name13:"關閉",
    name14:"地址:"
  },
  reserSuccess: {
    // name1:
    //   "開啟 Carlcare",
    name1: "請將預約資訊截圖後另存為收據，以便優先取得服務。",
    name2: "提交成功",
    name3: "1. 清理資料",
    name4: "請事先備份手機上重要的個人資料",
    name5: "2. 停用開機密碼",
    name6: "前往服務商店之前，請先",
    name7: "服務商店",
    name8: "預約時間",
    name9: "故障說明",
    name10: "裝置型號",
    name11: "訂單編號",
    name12: "訂單資訊",
  },
  title: {
   
    name1: "支援以下國家：",
    name2: "選擇型號",
    name3: "預約",
    name4: "服務商店詳細資訊",
    name5: "選取服務商店",
  },
  error: {
    
    name1: "無資料。 請查看您的維修資訊",
    name2: "需要更多協助嗎？請聯絡我們。",
    name3: "對不起，目前所在地區沒有 Carlcare 中心。",
    name4: "請先選擇服務中心",
    name5: "安裝失敗",
    name6: "請先選擇裝置型號",
    name7: "詳細資料",
    name8: "請詳細說明您的需求",
    name9: "",
  },
  add1:{ //延用values-zh-rCN
    "name0": "values-zh-rCN",
    "name1": "您的订单已被确认，期待您的光临",
    "name2": "选择城市",
    "name3": "请输入%1$s位电话号码",
    "name4": "营业时间",
    "name5": "星期一",
    "name6": "星期二",
    "name7": "星期三",
    "name8": "星期四",
    "name9": "星期五",
    "name10": "星期六",
    "name11": "星期天",
    "name12": "输入国家名称并搜索"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "其他",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"點此進行",
    name3:"打開 Carlcare 應用程式以評價訂單",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"選擇服務",
    name7:"免費清理",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "資訊不正確",
    "cancelReason1": "不能準時抵達",
    "cancelReason2": "訂單重複/不是我的訂單",
    "cancelReason3": "不再出現異常",
    "cancelReason4": "僅供測試/查詢/事件/…",
    "cancelReason5": "價格高",
    "cancelReason6": "材料短缺",
    "cancelReason7": "無差異化服務",
    "cancelReason8": "這家商店太遠",
    "cancelReason9": "這家商店已打烊",
    "cancelReason10": "服務態度不佳",
    "cancelReason11": "更換/維修其他品牌",
    "cancelReason12": "找不到商店",
    "cancelReason13": "其他",
    "cancelOrder": "取消訂單",
    "reason_dialog_title": "請告訴我們取消的理由",
    "Cancel": "取消",
    "OK": "確定",
    "name1": "輸入驗證碼",
    "name2": "驗證碼無效",
    "repair_reservation_detail_canceled": "此訂單已取消！",
    "purchase_cancel_dialog_content": "您確認取消訂單嗎？",
    "yes": "是",
    "no": "否"
}
};
